module.exports = __webpack_public_path__ + "media/img/vca/nomg2-1babdc62d44d7d053c44d84aec0143e0.png";